import { View } from "binder"
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { CashGatewayViewModel } from "./cashGateway-viewModel"

export class CashGatewayView extends View<CashGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-D43CC084-7DD2-4A5B-B218-DCCFA1A7F548"
    }
    loadHtml(): string {
        let element = require('./cashGateway.html').default;
        let style = require('./cashGateway.less');
        return element;
    }
    constructor() {
       super();
    }

    public set district(v: DistrictSelector) { this._district = v; } public get district(): DistrictSelector { return this._district;} private _district: DistrictSelector;
}
